import { AxiosResponse } from 'axios';
import ariInterceptor from '../utils/ariInterceptor';
import { Campus } from '../types/UbicacionesAri/Campus';
import { Zona } from '../types/UbicacionesAri/Zona';
import { Bloque } from '../types/UbicacionesAri/Bloque';
import { Ubicacion } from '../types/UbicacionesAri/Ubicacion';
import { TipoUbicacion } from '../types/UbicacionesAri/TipoUbicacion';

const SERV_BACK: string = process.env.REACT_APP_API_ARI || '';
const APIARI = 'api/Ubicaciones/';

export default class AriService {

    static async GetListaCampus(): Promise<Array<Campus>> {
        const response1: AxiosResponse<Array<Campus>> = await ariInterceptor.get(`${SERV_BACK}${APIARI}ObtenerCampusList`,
            {
                headers: {
                    "Content-type": "application/json",
                },
            }
        );
        return response1.data;
    }

    static async GetListaZonas(idCampus?: number): Promise<Array<Zona>> {
        const queryParam = idCampus !== undefined ? `?idCampus=${idCampus}` : '';
        const response1: AxiosResponse<Array<Zona>> = await ariInterceptor.get(
            `${SERV_BACK}${APIARI}ObtenerZonasList/${queryParam}`,
            {
                headers: {
                    "Content-type": "application/json",
                },
            }
        );
        return response1.data;
    }

    static async GetListaBloques(idZona?: number, bloques?: Array<number>): Promise<Array<Bloque>> {
        const params: string[] = [];

        if (idZona !== undefined) {
            params.push(`idZona=${idZona}`);
        }

        if (bloques && bloques.length > 0) {
            params.push(...bloques.map(id => `idGrupoTipo=${id}`));
        }

        const queryParam = params.length > 0 ? `?${params.join("&")}` : "";
        const response1: AxiosResponse<Array<Bloque>> = await ariInterceptor.get(
            `${SERV_BACK}${APIARI}ObtenerBloques/${queryParam}`,
            {
                headers: {
                    "Content-type": "application/json",
                },
            }
        );
        return response1.data;
    }

    static async GetListaTipoUbicacion(idBloque?: number, subtipo?: string): Promise<Array<TipoUbicacion>> {
        const params = new URLSearchParams();

        if (idBloque !== undefined) {
            params.append('idBloque', idBloque.toString());
        }

        if (subtipo !== undefined) {
            params.append('idGrupoTipo', subtipo);
        }
        const queryParam = params.toString() ? `?${params.toString()}` : '';
        const response1: AxiosResponse<Array<TipoUbicacion>> = await ariInterceptor.get(
            `${SERV_BACK}${APIARI}ObtenerTiposUbicaciones/${queryParam}`,
            {
                headers: {
                    "Content-type": "application/json",
                },
            }
        );
        return response1.data;
    }

    static async GetListaUbicacion(idBloque?: number, idGrupoTipo?: number): Promise<Array<Ubicacion>> {
        const params = new URLSearchParams();

        if (idBloque !== undefined) {
            params.append('idBloque', idBloque.toString());
        }

        if (idGrupoTipo !== undefined) {
            params.append('idGrupoTipo', idGrupoTipo.toString());
        }

        const queryParam = params.toString() ? `?${params.toString()}` : '';
        const response1: AxiosResponse<Array<Ubicacion>> = await ariInterceptor.get(
            `${SERV_BACK}${APIARI}ObtenerUbicacionesBloque${queryParam}`,
            {
                headers: {
                    "Content-type": "application/json",
                },
            }
        );
        return response1.data;
    }

}